import React from 'react';
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";

// คอมโพเนนต์สำหรับหัวข้อ (ทำรูปร่างคล้ายป้ายริบบิ้นตามภาพ) [cite: 1]
const SectionTitle = ({ title }) => (
  <div className="mb-6 relative z-10">
    <div className="inline-block bg-[#dca854] text-[#4a2e1b] font-bold text-2xl py-2 px-8 shadow-md border-l-[16px] border-[#6b4226]"
      style={{ clipPath: 'polygon(0 0, 90% 0, 100% 50%, 90% 100%, 0 100%)', paddingRight: '2.5rem' }}>
      {title}
    </div>
  </div>
);

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-[#f7f4ec] font-sans text-[#4a2e1b] flex flex-col">
      {/* ส่วนหัวของเว็บไซต์ */}
      <SiteHeader />

      {/* เนื้อหาหลัก */}
      <main className="flex-grow py-12 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
        {/* Background Texture Overlay */}
        <div className="absolute inset-0 opacity-10 pointer-events-none"
          style={{ backgroundImage: 'radial-gradient(#4a2e1b 1px, transparent 1px)', backgroundSize: '20px 20px' }}></div>

        {/* Header Section */}
        <div className="text-center mb-16 relative z-10">
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#9c5a33] mb-4 drop-shadow-sm">
            รักอ่าน รักษ์วัฒนธรรม
          </h1>
          <h2 className="text-xl md:text-2xl font-bold text-[#4a2e1b]">
            เครือข่ายอนุรักษ์และเผยแพร่เอกสารโบราณและหนังสือหายาก
          </h2>
        </div>

        {/* Main Content - Two Column Layout */}
        <div className="max-w-6xl mx-auto relative flex flex-col md:flex-row gap-12 md:gap-0 z-10">

          {/* Center Dashed Line */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0 border-l-[3px] border-dashed border-[#8b5a33] -translate-x-1/2 z-0">
            <div className="absolute w-4 h-4 bg-[#6b4226] rounded-full left-1/2 -translate-x-1/2 top-0"></div>
            <div className="absolute w-4 h-4 bg-[#6b4226] rounded-full left-1/2 -translate-x-1/2 top-[30%]"></div>
            <div className="absolute w-4 h-4 bg-[#6b4226] rounded-full left-1/2 -translate-x-1/2 top-[70%]"></div>
            <div className="absolute w-4 h-4 bg-[#6b4226] rounded-full left-1/2 -translate-x-1/2 bottom-0"></div>
          </div>

          {/* ================= LEFT COLUMN ================= */}
          <div className="w-full md:w-1/2 md:pr-12 lg:pr-16 flex flex-col gap-10">

            <div className="text-sm md:text-base leading-relaxed text-justify">
              <p className="indent-8">
                โครงการบูรณาการความร่วมมือด้านห้องสมุดและงานด้านมรดกศิลปวัฒนธรรมร่วมกับหน่วยงานที่เกี่ยวข้องในลักษณะของเครือข่ายด้านการอนุรักษ์และเผยแพร่เอกสารโบราณและหนังสือหายากที่สำคัญและ มีคุณค่าในระดับท้องถิ่นสู่ระดับภูมิภาค  โดยรวบรวม อนุรักษ์ เผยแพร่ ประชาสัมพันธ์และส่งเสริมการเรียนรู้ให้เกิดการใช้ประโยชน์จากเอกสารหลักฐานที่สำคัญ เหล่านี้ เพิ่มการเข้าถึงเอกสารโบราณและหนังสือหายาก ทั้งในรูปแบบต้นฉบับและดิจิทัล ผ่านระบบออนไลน์         อีกทั้งทำหน้าที่ในการเชื่อมโยง และสนับสนุนการทำงานของชุมชน การแลกเปลี่ยนและการเรียนรู้ที่สำคัญของเครือข่ายระดับภูมิภาค
              </p>
            </div>

            <div className="w-full bg-gray-300 aspect-[16/9] rounded-lg overflow-hidden shadow-md border-4 border-[#eaddc4] flex items-center justify-center text-gray-500">
              <img
                src="./AboutPage/5.jpg"
                alt="Website Platform"
                className="w-full h-full object-cover"
              />
            </div>

            <div>
              <SectionTitle title="วัตถุประสงค์" />
              <ul className="space-y-3 text-sm md:text-base">
                {[
                  "เพื่อสร้างเครือข่ายอนุรักษ์และเผยแพร่เอกสารโบราณและหนังสือหายากในระดับท้องถิ่นสู่ระดับภูมิภาค",
                  "เพื่อสร้างความรู้ ความเข้าใจเกี่ยวกับการจัดการมรดกภูมิปัญญาทางวัฒนธรรมด้านเอกสารโบราณและหนังสือหายาก",
                  "เเพื่อเผยแพร่ ประชาสัมพันธ์ และส่งเสริมการเรียนรู้ ให้ประชาชนสามารถใช้ประโยชน์จากเอกสารโบราณ และหนังสือหายาก",
                  "เพื่อเพิ่มการเข้าถึงเอกสารโบราณและหนังสือหายาก ทั้งในรูปแบบเอกสารต้นฉบับและดิจิทัล ผ่านระบบบริการออนไลน์",
                  "เพื่อนำเทคโนโลยีสารสนเทศมาประยุกต์ใช้ใน การพัฒนาแหล่งเรียนรู้และแหล่งมรดกศิลปวัฒนธรรมให้มีคุณภาพ ทันสมัยได้อย่างมีมาตรฐาน"
                ].map((text, idx) => (
                  <li key={idx} className="flex items-start">
                    <span className="min-w-2 h-2 mt-2 mr-3 bg-[#6b4226] rounded-full block"></span>
                    <span>{text}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <SectionTitle title="เป้าหมาย" />
              <p className="text-sm md:text-base leading-relaxed text-justify indent-8 bg-[#efebd8] p-4 rounded-xl border border-[#d2c4aa]">
                เครือข่ายอนุรักษ์และเผยแพร่เอกสารโบราณ และหนังสือหายาก ประกอบด้วย หอสมุดแห่งชาติ  ห้องสมุด สถาบันการศึกษา หน่วยงาน สมาคม  องค์กร วัด ชุมชน และบุคคลที่เกี่ยวข้องใน ด้านการจัดการมรดกภูมิปัญญาทางวัฒนธรรม ทั้งในและต่างประเทศ จากระดับท้องถิ่นสู่ระดับภูมิภาค
              </p>
            </div>
          </div>

          {/* ================= RIGHT COLUMN ================= */}
          <div className="w-full md:w-1/2 md:pl-12 lg:pl-16 flex flex-col gap-6 pt-4 md:pt-0">
            <SectionTitle title="กิจกรรม" />
            <div className="space-y-6 text-sm md:text-base">
              <div className="flex items-start">
                <span className="min-w-2 h-2 mt-2 mr-3 bg-[#6b4226] rounded-full block"></span>
                <p>สร้างเครือข่ายอนุรักษ์และเผยแพร่เอกสารโบราณ และหนังสือหายาก “รักอ่าน รักษ์วัฒนธรรม Culture Reader” </p>
              </div>
              <div className="flex items-start">
                <span className="min-w-2 h-2 mt-2 mr-3 bg-[#6b4226] rounded-full block"></span>
                <p>พัฒนาระบบฐานข้อมูล (Database) หรือแพลตฟอร์ม (Platform) ในการทำงานร่วมกันระหว่างเครือข่าย ทั้งการบริหารจัดการ การแลกเปลี่ยน และบริการทรัพยากรสารสนเทศด้านเอกสารโบราณและหนังสือหายาก </p>
              </div>
              <div className="w-full bg-gray-300 aspect-[2/1] rounded-lg overflow-hidden shadow-md my-4 border-4 border-[#eaddc4] flex items-center justify-center text-gray-500">
                <img
                src="./AboutPage/4.jpg"
                alt="Website Platform"
                className="w-full h-full object-cover"
              />
              </div>

              <div className="flex items-start">
                <span className="min-w-2 h-2 mt-2 mr-3 bg-[#6b4226] rounded-full block"></span>
                <p>จัดนิทรรศการด้านเอกสารโบราณและหนังสือ           หายาก และจัดทำสื่อเผยแพร่ประชาสัมพันธ์          ทั้งป้าย บอร์ด นิทรรศการออนไลน์ อินโฟกราฟฟิก วีดีทัศน์ สื่อมีเดีย เผยแพร่ผ่านช่องทาง สื่อสังคมออนไลน์ ทั้งเว็บไซต์ Facebook tiktok ภายใต้ชื่อ “รักอ่าน รักษ์วัฒนธรรม Culture Reader”</p>
              </div>
              <div className="flex items-start">
                <span className="min-w-2 h-2 mt-2 mr-3 bg-[#6b4226] rounded-full block"></span>
                <p>จัดอบรม สัมมนาเกี่ยวกับด้านเอกสารโบราณและหนังสือหายาก ทั้งการบรรยาย ประชุม อบรม          เชิงปฏิบัติการโดยวิทยากรผู้เชี่ยวชาญด้านเอกสารโบราณและหนังสือหายาก ทั้งจากในและ              ต่างประเทศ </p>
              </div>
              <div className="w-full bg-gray-300 aspect-[16/9] rounded-lg overflow-hidden shadow-md my-4 border-4 border-[#eaddc4] flex items-center justify-center text-gray-500">
                <img
                src="./AboutPage/3.jpg"
                alt="Website Platform"
                className="w-full h-full object-cover"
              />
              </div>

              <div className="flex items-start">
                <span className="min-w-2 h-2 mt-2 mr-3 bg-[#6b4226] rounded-full block"></span>
                <p>จัดตั้งเครือข่ายอาสาสมัครท้องถิ่นในการดูแลมรดกทางศิลปวัฒนธรรม (อส.มศ) ด้านเอกสารโบราณและหนังสือหายาก</p>
              </div>
              <div className="w-full  aspect-[1/1] rounded-lg overflow-hidden shadow-md my-4  flex items-center justify-center ">
                <img
                src="./AboutPage/History.png"
                alt="Website Platform"
                className="w-full h-full object-cover"
              />
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* ส่วนท้ายของเว็บไซต์ */}
      <Footer />
    </div>
  );
};

export default AboutPage;